// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCVFvUjCnYksgjfr41MNnxFn75uBunRXZI",
  authDomain: "devchat-1de61.firebaseapp.com",
  projectId: "devchat-1de61",
  storageBucket: "devchat-1de61.appspot.com",
  messagingSenderId: "839983456417",
  appId: "1:839983456417:web:75d13a84bbf0eec7c090e0",
  measurementId: "G-G76YHTQ7FF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore();
